import { createAsyncThunk } from '@reduxjs/toolkit'

import { Comment, CommentsResponse } from '../../types/commentTypes'
import {
  addCommentApi,
  deleteCommentApi,
  getCommentbyIdApi,
  getCommentByActionIdApi,
  updateCommentApi,
} from '../../api/commentApi'
import { handleError } from '../../utils/errorHandler'

export const deleteComment = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('comment/deleteComment', async (_id, thunkAPI) => {
  try {
    await deleteCommentApi(_id)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addComment = createAsyncThunk<
  Comment,
  Comment,
  { rejectValue: string }
>('comment/addComment', async (newComment, thunkAPI) => {
  try {
    const response = await addCommentApi(newComment)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getCommentbyId = createAsyncThunk<
  Comment,
  string,
  { rejectValue: string }
>('comment/getCommentbyId', async (CommentId, thunkAPI) => {
  try {
    const response = await getCommentbyIdApi(CommentId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updateComment = createAsyncThunk<
  Comment,
  { updatedComment: Comment; _id: string },
  { rejectValue: string }
>('comment/updateComment', async ({ updatedComment, _id }, thunkAPI) => {
  try {
    const response = await updateCommentApi(updatedComment, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getCommentsByActionId = createAsyncThunk<
  CommentsResponse,
  string,
  { rejectValue: string }
>('comment/getCommentsByActionId', async (ActionId, thunkAPI) => {
  try {
    const response = await getCommentByActionIdApi(ActionId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
